import { TimePicker, message } from "antd"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { IoTrashOutline } from "react-icons/io5"
import styled from "styled-components"

import AppButton from "../../../../../../_shared/components/AppButton"
import FloatingButton from "../../../../../../_shared/components/FloatingButton"
import DatePicker from "../../../../../../_shared/components/FormItems/PlainDatePicker"
import AppHeading from "../../../../../../_shared/components/Typography/Heading"
import { sortFunction } from "../DateChangeForm"
import { hasOverlap } from "../util"

// ----------------------------------------------------------------------------

function DateForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { values, onValueChange } = props

    const days = values?.days

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [adding, setAdding] = useState(false)
    const [newDate, setNewDate] = useState()
    const [newStartTime, setNewStartTime] = useState("09:00")
    const [newEndTime, setNewEndTime] = useState("18:00")

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function addDate() {
        setAdding(true)
    }

    function updateDays() {
        if (!values?.eventType) {
            message.error(
                "Selezionare una tipologia di evento per impostare le date"
            )
            return
        }

        const dateToAdd = {
            date: newDate,
            startTime: newStartTime,
            endTime: newEndTime,
        }
        const overlapValidation = values.days.some((day) =>
            hasOverlap(day, dateToAdd)
        )

        if (overlapValidation) {
            message.error(
                "La data selezionata ha una sovrapposizione con una giornata già configurata"
            )
            return
        }
        const newDays = values?.days ? [...values.days, dateToAdd] : [dateToAdd]
        newDays.sort(sortFunction)
        onValueChange("days", { recomputeSlots: true, changedField: "days" })(
            newDays
        )
        handleCancel()
    }

    function deleteDay(index) {
        return () => {
            const newDays = [...values?.days]
            newDays.splice(index, 1)
            onValueChange("days", {
                recomputeSlots: true,
                changedField: "days",
            })(newDays)
        }
    }

    function handleCancel() {
        setAdding(false)
        setNewDate("")
        setNewStartTime("09:00")
        setNewEndTime("18:00")
    }

    function renderDates() {
        return days?.map((day, index) => (
            <div key={index} className="date-card">
                <div className="content">
                    <div className="field">
                        <span className="label">Data</span>
                        <span className="value">{day.date}</span>
                    </div>

                    <div className="field">
                        <span className="label">Ora inizio</span>
                        <span className="value">{day.startTime}</span>
                    </div>

                    <div className="field">
                        <span className="label">Ora fine</span>
                        <span className="value">{day.endTime}</span>
                    </div>
                </div>
                <FloatingButton onClick={deleteDay(index)}>
                    <IoTrashOutline className="icn" />
                </FloatingButton>
            </div>
        ))
    }

    function renderAddDate() {
        const format = "HH:mm"
        return (
            <div className="new-date">
                <div className="field">
                    <AppHeading className="heading">Data</AppHeading>
                    <DatePicker
                        className="date-picker"
                        value={newDate}
                        onChange={(e) => setNewDate(e)}
                    ></DatePicker>
                </div>
                <div className="field">
                    <AppHeading className="heading">Ora inizio</AppHeading>
                    <TimePicker
                        className="input"
                        value={moment(newStartTime, format)}
                        format={format}
                        onChange={(_, dateString) => {
                            setNewStartTime(dateString)
                        }}
                    ></TimePicker>
                </div>
                <div className="field">
                    <AppHeading className="heading">Ora fine</AppHeading>
                    <TimePicker
                        className="input"
                        value={moment(newEndTime, format)}
                        format={format}
                        onChange={(_, dateString) => {
                            setNewEndTime(dateString)
                        }}
                    ></TimePicker>
                </div>
                <AppButton
                    onClick={updateDays}
                    uxType="primary"
                    htmlType="button"
                >
                    Conferma
                </AppButton>
                <AppButton
                    onClick={handleCancel}
                    uxType="delete"
                    htmlType="button"
                >
                    Annulla
                </AppButton>
            </div>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            <div className="dates">
                {renderDates()}
                {adding && renderAddDate()}
            </div>
            {!adding && (
                <AppButton
                    onClick={addDate}
                    uxType="secondary"
                    htmlType="button"
                >
                    Nuova giornata
                </AppButton>
            )}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

DateForm.propTypes = {
    className: PropTypes.string.isRequired,
    values: PropTypes.object,
    onValueChange: PropTypes.func,
    eventTypes: PropTypes.array,
}

DateForm.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledBioForm = styled(DateForm)`
    & {
        .heading {
            margin-top: 20px;
        }
        .dates {
            margin-bottom: 40px;
            .new-date {
                margin-top: 20px;
                display: flex;
                align-items: flex-end;
                .field {
                    margin-right: 20px;
                }
                button {
                    height: 32px;
                    margin-left: 10px;
                }
            }
            .date-card {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .content {
                    background-color: ${({ theme }) =>
                        theme.colors.secondaryColor};
                    display: flex;
                    align-items: center;
                    /* justify-content: space-between; */
                    width: 500px;
                    height: 44px;
                    border-radius: 6px;
                    padding: 0px 15px;
                    margin-right: 15px;
                    .field {
                        margin-right: 20px;
                        .label {
                            font-size: 14px;
                        }
                        .value {
                            font-size: 16px;
                            margin-left: 5px;
                            font-weight: bold;
                            font-family: "Poppins-Bold";
                        }
                    }
                }
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledBioForm
